import Head from "next/head";

function strip(html) {
    var one = html.replace(/<\/?[^>]+(>|$)/gm, "");
    var two = one.replace(/[\r\n]\s*[\r\n]/gm, "");
    return two;
}

const Schema = ({ post }) => {

    return (
        <Head>
            <script dangerouslySetInnerHTML={{
                __html: JSON.stringify(post)
            }} type='application/ld+json'></script> </Head >);
};
export default Schema;